import { memo } from 'react';
import { SpinLoading } from 'antd-mobile';
import styles from '@/pages/school/chinese/teacher/index.module.scss';

interface LoadingMaskProps {
  visible?: boolean;
  text?: string;
}

export default memo(function LoadingMask({
  visible = true,
  text = '正在加载数据，请稍候…',
}: LoadingMaskProps) {
  if (!visible) return null;

  return (
    <div className={styles.loadingMask} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.loadingCard}>
        <SpinLoading color="#078579" />
        <span>{text}</span>
      </div>
    </div>
  );
});
